import React, { useState } from "react";
import { Button, Text } from "@ilc-technology/luik";
import { useDatasources } from "../../contexts/StoryblokContext/StoryblokContext";
import { LabelKey } from "../../Common/StoryblokTypes";
import UpgradeAccommodationModal from "./UpgradeAccommodationModal";
import { QuoteData } from "../../contexts/QuoteContext/QuoteContext";
import { Quote } from "../../Common/Types";

interface UpgradeAccommodationProps {
  isSaveInProgress: boolean;
  quote: Quote;
  quoteDraft: QuoteData;
}

export const UpgradeAccommodation: React.FC<UpgradeAccommodationProps> = ({ isSaveInProgress, quote, quoteDraft }) => {
  const { labels } = useDatasources();
  const [isModalOpen, setModalOpen] = useState(false);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div className="upgrade">
        <div className="flex cursor-default items-center justify-between py-2">
          <Text variant="paragraph-body-bold">{labels[LabelKey.headerAccommodation]}</Text>
        </div>
        <div className="upgrade a-gap-sm flex flex-col" data-testid="upgrade-accommodation-component">
          <Text variant="paragraph-body">{labels[LabelKey.changeAccommodationDescription]}</Text>
          <div className="flex justify-end pr-6">
            <Button
              data-testid="change-accommodation-button"
              size="base"
              intent="primary-black"
              onPress={handleModalOpen}
              isDisabled={isSaveInProgress}
            >
              {labels[LabelKey.upgrade]}
            </Button>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <UpgradeAccommodationModal
          isModalOpen={isModalOpen}
          isSaveInProgress={isSaveInProgress}
          handleModalClose={handleModalClose}
          quote={quote}
          quoteDraft={quoteDraft}
        />
      )}
    </>
  );
};
